import { gql } from '@apollo/client'

export const GET_PAST_BIDS = gql`
  query GetPastBids($fantasyLeagueId: ID!, $limit: Int, $offset: Int) {
    fantasyLeagueMemberPastBids(
      fantasyLeagueId: $fantasyLeagueId
      limit: $limit
      offset: $offset
    ) {
      id
      amount
      status
      createdAt
      marketEntry {
        id
        seller {
          id
          teamName
        }
        player {
          id
          createdAt
          nick
          name
          lastName
          image
          role
          totalScore
          lastWeekNumber
          lastWeekScore
          marketValue
          team {
            id
            competition {
              id
              code
              displayName
              rank
            }
            createdAt
            nameShow
            shortName
            shield
          }
        }
      }
      bidder {
        id
        teamName
      }
    }
  }
`
